import { useEffect, useState } from 'react'
import service from '../../services/service'
import endpoints from '../../services/endpoints'

const clip = (value) => String(value ?? '').slice(0, 100)

// Matches how SaveToWishlistButton builds record_id/record_module when saving
// — must stay identical or lookups here will never hit.
export const wishlistItemKey = (recordModule, recordId) => `${String(recordModule || '').toLowerCase()}:${clip(recordId)}`

// Fetches the user's individual (default) wishlist's items once per page, so
// result-list cards can render already-favorited as saved from first paint
// instead of starting blank — without this, re-tapping an already-saved item
// hits the backend's "This item is already in the wishlist" 400 with no visual
// cue beforehand. One call for the whole page, not one per card.
const useIndividualWishlistItems = () => {
    const [individualId, setIndividualId] = useState(null)
    const [savedMap, setSavedMap] = useState(new Map())

    useEffect(() => {
        let cancelled = false
        service
            .get(endpoints.wishlists.list, {}, { silent: true })
            .then(({ data }) => {
                const all = Array.isArray(data.data) ? data.data : []
                const individual = all.find((w) => w.type === 'individual')
                if (!individual?.id) return null
                if (!cancelled) setIndividualId(individual.id)
                return service.get(
                    endpoints.wishlists.items.replace('{wishlist_id}', individual.id),
                    { page_size: 100 },
                    { silent: true },
                )
            })
            .then((res) => {
                if (cancelled || !res) return
                const items = Array.isArray(res.data?.data) ? res.data.data : []
                const map = new Map()
                items.forEach((it) => {
                    map.set(wishlistItemKey(it.record_module, it.record_id), it.id)
                })
                setSavedMap(map)
            })
            .catch(() => {})
        return () => {
            cancelled = true
        }
    }, [])

    return { individualId, savedMap }
}

export default useIndividualWishlistItems
